(function() {
  'use strict';

  angular.module('app').factory('PrepaidService', PrepaidService);

  PrepaidService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function PrepaidService($rootScope, API, NotifyService) {
    var service = {};

    var _req_gc = [];

    initVars();

    function initVars() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = {};
    }

    $rootScope.$on('user-login', function() {
      initVars();
    });

    $rootScope.$on('user-register', function() {
      initVars();
    });

    $rootScope.$on('user-logout', function() {
      for (var i in _req_gc)
        $rootScope[_req_gc[i]] = null;
    });

    // -------------------------------------------------------------------------------------------------------------

    service.Series = function(params, callback) {
      API.get('/tour_cards/batches?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.getSeries = function(id, callback) {
      API.get('/tour_cards/batches/{0}'.format(id), callback);
    };

    service.SeriesAdd = function(post_data, callback) {
      API.post('/tour_cards/batches', post_data, callback);
    };

    service.SeriesEdit = function(post_data, callback) {
      API.patch('/tour_cards/batches/{0}'.format(post_data.id), post_data, callback);
    };

    service.UploadSeriesPhoto = function(id, data, callback) {
      API.postImage('/tour_cards/batches/' + id + '/photo', data, callback);
    };

    service.SeriesCodes = function(id, params, callback) {
      API.get('/tour_cards/batches/{0}/codes?{1}'.format(id, paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.SeriesCodesAdd = function(id, post_data, callback) {
      API.post('/tour_cards/batches/{0}/codes/add'.format(id), post_data, callback);
    };

    service.SeriesCodeDelete = function(id, code, callback) {
      API.post('/tour_cards/batches/{0}/codes/delete'.format(id), [code], callback);
    };

    // -------------------------------------------------------------------------------------------------------------

    service.GenerateCards = function(id, post_data, callback) {
      API.post('/tour_cards/batches/{0}/emit'.format(id), post_data, callback);
    };

    service.PrepaidCards = function(params, callback) {
      API.get('/tour_cards/cards?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.CardCancel = function(id, callback) {
      API.get('/tour_cards/cards/{0}/cancel'.format(id), callback);
    };

    // -------------------------------------------------------------------------------------------------------------

    service.Accounts = function(params, callback) {
      API.get('/tour_cards/accounts?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.getAccount = function(id, callback) {
      API.get('/tour_cards/accounts/{0}'.format(id), callback);
    };

    service.AccountAdd = function(post_data, callback) {
      API.post('/tour_cards/accounts', post_data, callback);
    };

    service.AccountEdit = function(post_data, callback) {
      API.patch('/tour_cards/accounts/{0}'.format(post_data.id), post_data, callback);
    };

    // -------------------------------------------------------------------------------------------------------------

    service.Cards = function(params, callback) {
      API.get('/tour_cards/cards?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    // -------------------------------------------------------------------------------------------------------------

    service.Categories = function(params, callback) {
      API.get('/tour_cards/services/categories?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.getCategory = function(id, callback) {
      API.get('/tour_cards/services/categories/{0}'.format(id), callback);
    };

    service.CategoryAdd = function(post_data, callback) {
      API.post('/tour_cards/services/categories', post_data, callback);
    };

    service.CategoryEdit = function(post_data, callback) {
      API.patch('/tour_cards/services/categories/{0}'.format(post_data.id), post_data, callback);
    };

    // -------------------------------------------------------------------------------------------------------------

    service.Services = function(params, callback) {
      API.get('/tour_cards/services?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), callback);
    };

    service.getService = function(id, callback) {
      API.get('/tour_cards/services/{0}'.format(id), callback);
    };

    service.ServiceAdd = function(post_data, callback) {
      API.post('/tour_cards/services', post_data, callback);
    };

    service.ServiceEdit = function(post_data, callback) {
      API.patch('/tour_cards/services/{0}'.format(post_data.id), post_data, callback);
    };

    service.UploadServicePhoto = function(id, data, callback) {
      API.postImage('/tour_cards/services/' + id + '/photo', data, callback);
    };

    service.getServicePos = function(id, callback) {
      API.get('/tour_cards/services/{0}/pos'.format(id), callback);
    };

    service.ServicePosEdit = function(id, post_data, callback) {
      API.post('/tour_cards/services/{0}/pos'.format(id), post_data, callback);
    };

    return service;
  }

})();
